import { useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Button,
} from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import CalendlyDetails from "./calendlyDetails";
import Branding from "../../../src/scenes/nftTokenGatingData/components/customization";
import CalendlyTokenGatingConfiguration from "./calendlyTokenGatingConfiguration";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

const steps = [" Calendly Details", "Token Gating Configuration", "Branding Details"];

const CalendlyTokenGatingForm = () => {
  const {
    register,
  } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);

  const [calendlyDetails, setCalendlyDetails] = useState({
      calendlyName:""
  });

  const [calendlyNftTokenGatingData, setCalendlyNftTokenGatingData] = useState([
    {
      contractAddress: "",
      tokenId: "",
      nftsRequired: "",
      tokenStandard: "",
      blockChain: "",
    },
  ]);

  const [calendlyBrandingDetails,setCalendlyBrandingDetails]=useState(
    {
      connectWalletButtonColor: "#d9534f",
      connectWalletButtonText: "Connect Wallet",
      connectWalletButtonTextColor: '#ffffff',
      buyNFTButtonColor: "#5cb85c",
      buyNFTButtonText: "Buy NFT",
      buyNFTButtonTextColor: '#ffffff',
      restrictedContentMessageHeader : 'Access to this Calendly Meet is restricted',
      restrictedContentMessage : 'Please login with your crypto wallet to verify your NFT ownership',
      errorMessageHeader : 'You are not authorized to access this Calendly Scheduler',
      errorMessage : 'The NFT is required to view this page',
      linkToBuyNft: "https://opensea.io",
      homePageRedirectionLink: "/",
      customLogo : process.env.REACT_APP_BASE_URL + "/default-logo",
    }
  )


  const onHandleCustomLogo = async(event) => {
    const data = event.target.files[0];
    if ( data.size > 2 * 1000000) {
      swal({
        title: 'Size is greater than 2 MB.',
        icon: "error",
      });
    }
    const { name, value } = event.target;
    const formData = new FormData();
    formData.append('image', data);
    let response = await axios({
      method : "post",
      url : `${process.env.REACT_APP_BASE_URL}/upload-logo`,
      data: formData,
      headers: {
        "content-type": "application/json",
      }
    });
    let imageId = response.data.response;
    let imagePath = await axios({
      method : "get",
      url : `${process.env.REACT_APP_BASE_URL}` + '/uploads/' + imageId,
    });
    imagePath = imagePath.config.url;
    imagePath = imagePath.replace(/\\/g, "/");
    setCalendlyBrandingDetails({
      ...calendlyBrandingDetails,
      [name]: imagePath,
    });
  }

  const onHandleBrandingInputChange = (event) => {
    const { name, value } = event.target;
    setCalendlyBrandingDetails({
      ...calendlyBrandingDetails,
      [name]: value,
    });
  };

  const onHandleCalendlyDetailsInputChange = (event) => {
    const { name, value } = event.target;
    setCalendlyDetails({
      ...calendlyDetails,
      [name]: value,
    });
  };

  const onHandleCalendlyNftTokenGatingDataInputChange = (event, index) => {
    const { name, value } = event.target;
    const listOfConfiguration = [...calendlyNftTokenGatingData];
    listOfConfiguration[index][name] = value;
    setCalendlyNftTokenGatingData(listOfConfiguration);
  };
  //removes page path field if remove button clicked dynamically
  const handleRemoveClick = (index) => {
    const listOfConfiguration = [...calendlyNftTokenGatingData];
    listOfConfiguration.splice(index, 1);
    setCalendlyNftTokenGatingData(listOfConfiguration);
  };
  //adds more page path field if add button clicked dynamically
  const handleAddClick = () => {
    setCalendlyNftTokenGatingData([
      ...calendlyNftTokenGatingData,
      {
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };
  

  const handleNext = (event) => {
    event.preventDefault();
    setActiveStep((prevStep) => prevStep + 1);
    if (activeStep === steps.length - 1) {
        setActiveStep((prevStep) => prevStep - 1);
      let calendlyTokenGatingData={
        calendlyName : calendlyDetails.calendlyName,
        calendlyBrandingDetails,
        calendlyNftTokenGatingData
      }
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/calendly-nft-token-gating-data-save`,
          {
            calendlyTokenGatingData,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          swal({
            text: "Calendly NFT Token Gating has been enabled ",
            icon: "success",
          });
          navigate("/configured-apps");
        })
        .catch((err) => {
          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        });
    }
  };
  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const formContent = (step) => {
    switch (step) {
      case 0:
        return (
          <CalendlyDetails
          onHandleCalendlyDetailsInputChange={
            onHandleCalendlyDetailsInputChange
            }
            calendlyDetails={calendlyDetails}
          />
        );
       case 1:
        return (
          <CalendlyTokenGatingConfiguration
             onHandleCalendlyNftTokenGatingDataInputChange={
            onHandleCalendlyNftTokenGatingDataInputChange
            }
            calendlyNftTokenGatingData={calendlyNftTokenGatingData}
            handleRemoveClick={handleRemoveClick}
            handleAddClick={handleAddClick}
          />
        );
        case 2:
          return (
            <Branding
              onHandleNftCustomizationInputChange={
              onHandleBrandingInputChange
            }  
           onHandleCustomLogo={
            onHandleCustomLogo
           }
          nftCustomizationDetails={
            calendlyBrandingDetails
          }

            />
          );
      default:
        return <div>404: Not Found</div>;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "1000px",
        padding: 2,
        ml: 10,
      }}
    >
      <form onSubmit={handleNext}>
        <Box
          variant="gradient"
          borderRadius="lg"
          shadow="lg"
          opacity={1}
          p={3}
          textAlign="left"
          sx={{ bgcolor: "#f2f0f0", boxShadow: 2, height: 70 }}
        >
          <Stepper
            activeStep={activeStep}
            sx={{ fontSize: 10 }}
            orientation="horizontal"
          >
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Grid container>
          <Grid item xs={12} sx={{ padding: "20px" }}>
            {formContent(activeStep)}
          </Grid>
          <Grid item xs={12}>
            <Button
              size="small"
              variant="contained"
              color="info"
              disabled={activeStep == 0}
              sx={{
                ml: 11,
                mt: 1,
                mb: 3,
                backgroundColor: "#6870fa",
                boxShadow: 2,
              }}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              type="submit"
              size="small"
              variant="contained"
              color="info"
              sx={{
                ml: 2,
                mt: 1,
                mb: 3,
                backgroundColor: "#6870fa",
                boxShadow: 2,
              }}
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CalendlyTokenGatingForm;
